import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Wed Jul 18 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { jsonConversions, CategoryCleaningStateConverter } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
import { GenericTransportLayer } from '../GenericTransportLayer';
export var CategoryCleaningStateLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(CategoryCleaningStateLayer, _GenericTransportLaye);

  function CategoryCleaningStateLayer() {
    var _this;

    _classCallCheck(this, CategoryCleaningStateLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoryCleaningStateLayer).call(this, CONSTANTS.API.ENDPOINTS.CATEGORY_CLEANING_STATE));

    _this.findCleaningState = function (categoryId) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return api("".concat(CONSTANTS.API.ENDPOINTS.CLEANING_STATE(categoryId))).get({
                  responseType: 'json'
                });

              case 3:
                _ref = _context.sent;
                data = _ref.data;
                return _context.abrupt("return", this.converter.toObject(data.result, jsonConversions));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));
    };

    _this.copyDesignationToZones = function (data) {
      var startCleaningPromise = api("".concat(CONSTANTS.API.ENDPOINTS.CLEANING).concat(CONSTANTS.API.ENDPOINTS.COPY_DESIGNATION_TO_ZONES)).post(data, {
        responseType: 'json'
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return startCleaningPromise;
    };

    return _this;
  }

  _createClass(CategoryCleaningStateLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      var categoryCleaningStatePromise = api(this.baseUri).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this2.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return categoryCleaningStatePromise;
    }
    /**
     * Approves categories
     * @param categoryIds Selected category Ids
     */

  }, {
    key: "approveCategories",
    value: function approveCategories(categoryIds) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var endpoint, _ref2, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                endpoint = "".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.APPROVE);
                _context2.next = 3;
                return api(endpoint).post({
                  categoryIds: categoryIds
                }, {
                  responseType: 'json'
                });

              case 3:
                _ref2 = _context2.sent;
                data = _ref2.data;
                return _context2.abrupt("return", data);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "startCleaning",
    value: function startCleaning() {
      var startCleaningPromise = api("".concat(CONSTANTS.API.ENDPOINTS.CLEANING).concat(CONSTANTS.API.ENDPOINTS.START_CLEANING)).post(undefined, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.progress;
      });
      return startCleaningPromise;
    }
  }, {
    key: "lastCleaning",
    value: function lastCleaning() {
      var lastCleaningPromise = api("".concat(CONSTANTS.API.ENDPOINTS.CLEANING).concat(CONSTANTS.API.ENDPOINTS.LAST_CLEANING)).get({
        responseType: 'json'
      }).then(function (response) {
        return response.data.result;
      });
      return lastCleaningPromise;
    }
  }]);

  return CategoryCleaningStateLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", CategoryCleaningStateConverter)], CategoryCleaningStateLayer.prototype, "converter", void 0);